import { Link } from "react-router-dom";
import styled from "styled-components";

export const LinkButton = styled(Link)`
  color: #0054e3;
  font-size: 14px;
  text-decoration: none;
  font-weight: 500;
  gap: 6px;
  display: flex;
  font-family: "Inter";
  align-items: center;
  .arrow-icon {
    transition: transform 0.3s ease;
  }
  &:hover .arrow-icon {
    transform: translateX(5px);
  }
`;
